import Meter from "../../../utils/services/project/metering/meterService";
import crudTemplate from "../../../templates/crudTemplate";
import predecessorsAndSuccessorsTemplate from "../../../templates/predecessorsAndSuccessorsTemplate";
let crud = crudTemplate(Meter);
let predecessorsAndSuccessors = predecessorsAndSuccessorsTemplate(Meter);
function prepareItem(item) {
  item._medium = item._medium || { id: null };
  item._groups = item._group
    ? [...(item._group._ancestors || []), item._group]
    : [];
  item._group = item._group || {};
  return item;
}
const state = {
  ...crud.state,
  ...predecessorsAndSuccessors.state
};
const getters = {
  ...crud.getters,
  ...predecessorsAndSuccessors.getters,
  getListSuccessors(state) {
    let list = predecessorsAndSuccessors.getters.getListSuccessors(state);
    return list.map(i => ({ ...i, ...prepareItem(i._meter) }));
  },
  getListPredecessors(state) {
    let list = predecessorsAndSuccessors.getters.getListPredecessors(state);
    return list.map(i => ({ ...i, ...prepareItem(i._meter) }));
  },
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  }
};

const actions = {
  ...crud.actions,
  ...predecessorsAndSuccessors.actions
};

const mutations = {
  ...crud.mutations,
  ...predecessorsAndSuccessors.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
